/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import {
  CONFIRM_PRICE_TAG_DISCLOSURE,
  PAY_FREQUENCY_LOOKUP,
  ADD_CHECKOUT_UID,
  ADD_VERIFICATION_CODE,
  CONFIRM_LEASE_AGREEMENT,
  CONFIRM_AON_AGREEMENT,
  CONFIRM_KPLUS_ACKNOWLEDGEMENT,
  CONFIRM_KPLUS_AGREEMENT,
  IS_AON_FLOW,
  ADD_USER_ID,
  CONFIRM_WARRANTY_AGREEMENT,
  ADD_CHECKOUT_ALL,
  CHANGE_FEATURE_LINEAR_FLOW,
  ADD_PAY_FREQUENCY,
  ADD_IN_STORE_CART_ITEM,
  UPDATE_IN_STORE_CART_ITEM,
  REMOVE_IN_STORE_CART_ITEM,
} from '../actionTypes';

const initialState = {
  payfrequencyExists: null,
  featureGateLinearFlow: true,
  uid: null,
  confirmedPriceTagDisclosure: false,
  confirmedLeaseAgreement: false,
  checkoutUid: null,
  checkout: {},
  availableLimit: null,
  billingState: null,
  verificationCode: null,
  vwo: [],
  // Items a shopper adds by hand in the in-store flow. Kept apart from `checkout`
  // because ADD_CHECKOUT_ALL replaces that object wholesale.
  inStoreCart: [],
};

export default function loanInfo(state = initialState, action) {
  switch (action.type) {
    case ADD_CHECKOUT_ALL: {
      return {
        ...state,
        checkout: action.payload,
        promotion: action.payload.promotion || false,
        userId: action.payload?.user_id ?? state.userId,
      };
    }
    case CONFIRM_PRICE_TAG_DISCLOSURE: {
      return {
        ...state,
        confirmedPriceTagDisclosure: true,
      };
    }
    case CONFIRM_LEASE_AGREEMENT: {
      return {
        ...state,
        confirmedLeaseAgreement: true,
      };
    }
    case CONFIRM_AON_AGREEMENT: {
      return {
        ...state,
        confirmedAonAgreement: action.payload,
      };
    }
    case CONFIRM_KPLUS_ACKNOWLEDGEMENT: {
      return {
        ...state,
        confirmedKplusAcknowledgement: true,
      };
    }
    case CONFIRM_KPLUS_AGREEMENT: {
      return {
        ...state,
        confirmedKplusAgreement: action.payload,
      };
    }
    case IS_AON_FLOW: {
      return {
        ...state,
        isAonFlow: action.payload,
      };
    }
    case ADD_USER_ID: {
      return {
        ...state,
        userId: action.payload,
      };
    }
    case CONFIRM_WARRANTY_AGREEMENT: {
      return {
        ...state,
        confirmedWarrantyAgreement: true,
      };
    }
    case PAY_FREQUENCY_LOOKUP: {
      const {
        available_limit: availableLimit,
        uid,
        payfrequency_exists: payfrequencyExists,
        pay_frequency: payFrequency,
        billing_state: billingState,
        vwo,
      } = action.payload;

      return {
        ...state,
        payfrequencyExists,
        availableLimit,
        payFrequency,
        billingState,
        uid,
        vwo,
      };
    }
    case ADD_VERIFICATION_CODE: {
      return {
        ...state,
        verificationCode: action.payload,
      };
    }
    case CHANGE_FEATURE_LINEAR_FLOW: {
      return {
        ...state,
        featureGateLinearFlow: action.payload,
      };
    }
    case ADD_PAY_FREQUENCY: {
      return {
        ...state,
        payFrequency: action.payload,
      };
    }
    case ADD_CHECKOUT_UID: {
      return {
        ...state,
        checkoutUid: action.payload,
      };
    }
    case ADD_IN_STORE_CART_ITEM: {
      return {
        ...state,
        // `|| []` covers a persisted state rehydrated from before this field existed.
        inStoreCart: [...(state.inStoreCart || []), action.payload],
      };
    }
    case REMOVE_IN_STORE_CART_ITEM: {
      return {
        ...state,
        inStoreCart: (state.inStoreCart || []).filter(item => item.id !== action.payload.id),
      };
    }
    case UPDATE_IN_STORE_CART_ITEM: {
      const { id, changes } = action.payload;
      return {
        ...state,
        // The id is spread last so an edit can never re-key an item.
        inStoreCart: (state.inStoreCart || []).map(item => (item.id === id ? { ...item, ...changes, id } : item)),
      };
    }
    default:
      return state;
  }
}
